 //const BASE_URL="http://192.168.1.12/bansal_group/"
 const BASE_URL="https://office.ubkinfotech.com/webservice/"

export const ConfigFile = {
  // BaseUrl: "http://192.168.1.12/bansal_group/api",
   //ImageUrl: "http://192.168.1.12//bansal_group/uploads",
  //  LocalUrl: "http://localhost:3000/",

    BaseUrl: `${BASE_URL}api`,
    IconUrl: `${BASE_URL}icons`,
    ImageUrl: `${BASE_URL}uploads`,
    LocalUrl: "http://officeadmin.ubkinfotech.com/",
};
